'use client';

import { useState, useEffect } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useSuspenseQuery } from '@apollo/client/react';
import { usePathname } from 'next/navigation';
import Header from '../components/header';
import MobileDrawer from '../components/mobile-drawer';
import theme from '../theme';
import { login, logout } from '../utils/auth';
import { meQuery, nearestCityQuery } from '../apollo/auth';
import AppContext from '../contexts/app';

type Props = {
  children?: React.ReactNode;
};

const Layout = (props: Props) => {
  const { children } = props;
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const pathname = usePathname();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });

  const { data: meData } = useSuspenseQuery(meQuery);
  const { me: loggedInUser } = meData || {};
  const isLoggedIn = Boolean(loggedInUser);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const { data: nearestCityData } = useSuspenseQuery(nearestCityQuery);
  const { nearestCity } = nearestCityData || {};

  function handleLogin(returnTo?: string) {
    login(returnTo);
  }

  function handleLogout(returnTo?: string) {
    logout(returnTo);
  }

  const appContext = {
    loggedInUser,
    isLoggedIn,
    mobileDrawerOpen,
    login: handleLogin,
    logout: handleLogout,
    setMobileDrawerOpen,
    nearestCity,
    city: loggedInUser?.primaryCity || nearestCity,
  };

  return (
    <AppContext.Provider value={appContext}>
      {isMobile && <MobileDrawer />}
      <Header />
      {children}
    </AppContext.Provider>
  );
};

export default Layout;
